<app-card [title]="report.nombre" [favorite]="report.favorito" (favoriteEvent)="onFavorite($event)">
    <div *ngIf=" report.auditoria?.fechaCreacion || report.auditoria?.nombreUsuarioModificacion" class="aditional-info">
        <span>{{ report.auditoria?.fechaCreacion | date: "shortDate" }}</span>
        <span *ngIf="report.auditoria?.fechaCreacion && report.auditoria?.nombreUsuarioModificacion"> | </span>
        <span> {{ report.auditoria?.nombreUsuarioModificacion }}</span>
    </div>
    <p *ngIf="report.descripcion" class="description">{{report.descripcion}}</p>
    <div class="options dropdown-center">
        <button type="button" class="btn" class="btn-generate" (click)="loadData()" [disabled]="hasOpenModals">
            Generar
        </button>
        <button *ngIf="hasPermission" class="ellipsis" data-bs-toggle="dropdown" aria-expanded="false">
            <fa-icon class="icon" [icon]="faEllipsis"></fa-icon>
        </button>
        <ul class="dropdown-menu">
            <li><button class=" dropdown-item" (click)="editReport()">Editar</button></li>
        </ul>
    </div>
</app-card>

<ngx-loading [show]="isLoading">
</ngx-loading>